import { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import InputBox from "../../../common/interactive/InputBox"
import PannelBody from "../../../fragments/PannelBody"
import { assignCaseLiability, assignCaseMajorMed, assignCaseMedPayUM, assignCaseWorkersComp, insuranceCarrierCreate } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"

import classes from './Create.module.css'

const resolveAssignedRecord = (response) => {
    if (!response || response.errorMessage) {
        return null
    }
    return response?.id ? response : response?.data
}

const CreateLiabilityForm = ({closeModal, folder, apiCase}) => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const isSubmittingRef = useRef(false)
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const insertAssignedRecord = (record) => {
        if (!record?.id) {
            return
        }

        if (folder === 'liabilities') {
            dispatch(caseActions.insertLiabilityInActiveCase(record))
        } else if (folder === 'mp_pip_um') {
            dispatch(caseActions.insertMedPayUMInActiveCase(record))
        } else if (folder === 'major_meds') {
            dispatch(caseActions.insertMajorMedInActiveCase(record))
        }
    }

    const submitHandler = async (event) => {
        event.preventDefault()

        if (isSubmittingRef.current) {
            return
        }
        isSubmittingRef.current = true
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)
            const formData = Object.fromEntries(fd.entries())

            const createData = await insuranceCarrierCreate(userToken, {
                name: formData.insurance_carrier_name
            })

            if (createData && createData.errorMessage) {
                dispatch(notificationActions.setError(createData))
                return
            }

            const reqBody = {
                insurance_carrier_id: createData.id,
                location_id: null,
                adjuster_id: null
            }

            let bindToCase
            if (folder === 'liabilities') {
                bindToCase = await assignCaseLiability(userToken, activeCase.case.id, reqBody)
            } else if (folder === 'mp_pip_um') {
                bindToCase = await assignCaseMedPayUM(userToken, activeCase.case.id, reqBody)
            } else if (folder === 'major_meds') {
                bindToCase = await assignCaseMajorMed(userToken, activeCase.case.id, reqBody)
            } else if (folder === 'worker_comp' || folder === 'worker_comps') {
                bindToCase = await assignCaseWorkersComp(userToken, activeCase.case.id, reqBody, dispatch)
            }

            if (bindToCase && bindToCase.errorMessage) {
                dispatch(notificationActions.setError(bindToCase))
                return
            }

            const record = resolveAssignedRecord(bindToCase)
            if (folder !== 'worker_comp' && folder !== 'worker_comps') {
                insertAssignedRecord(record)
            }

            closeModal()
        } finally {
            isSubmittingRef.current = false
            setIsLoading(false)
        }
    }

    return <form onSubmit={submitHandler}>
        <PannelBody padding='large'>
            <div className="row">
                <InputBox label="Insurance Carrier Name" type="text" name="insurance_carrier_name" required={true} placeholder="" />
            </div>
            
            <div className={classes.form_footer}>
                <Button type='submit' isLoading={isLoading} width={'full'}>
                    Submit 
                    <i className="ti ti-chevron-right"></i>
                </Button>
            </div>
        </PannelBody>
    </form>
}

export default CreateLiabilityForm
